import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Non-Invasive Preference';
const pageSubTitle = 'Non-Invasive Preference';
const videoKey = 'Lx3jGEB0N7c';

const NonInvasivePreference = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <p>
                    Non-Invasive Preference reflects how important it is to avoid treatments that
                    involve surgery, injections, or other invasive procedures. This may come from a
                    desire for less physical intrusion, faster recovery, or more comfort.
                    <br/>
                    For example:
                    <br/>
                    <ul style={{ marginLeft: 16 }}>
                        <li>
                            NSAIDs and Physical Therapy are non-invasive.
                        </li>
                        <li>
                            Injections—like PRP, Cortisone, and Hyaluronic Acid—are moderately invasive.
                        </li>
                        <li>
                            Total Knee Replacement is the most invasive.
                        </li>
                    </ul>
                    <br/>
                    This criterion helps identify treatments that align with a preference for simpler,
                    less physically invasive care.
                </p>
            }
            videoKey={videoKey}
            pageType="criteria"
        />
    );

};

export default NonInvasivePreference;